import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        textAlign: "center",
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans- serif',
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#333'
    },
    margin: {
        margin: theme.spacing(1),
    },
    header: {
        backgroundColor: '#3399cc',
        padding: '20px'
    }
}));

export default function SecurityDisclaimer () {
    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <div className={classes.header}>
                <h1>Security Disclaimer</h1>
            </div>
            <Container maxWidth="xl">
                <hr/>
                <h3>
                    This computer system is for authorized users only. Individuals using this computer system without authority, or in excess of their authority, are subject to having all their activities on this system monitored and recorded by system personnel. If necessary, appropriate corrective action will be taken against individuals when misuse and/or unauthorized use is detected. Corrective actions may include, without limitation, counseling, suspension or employment termination, depending upon the severity of the misuse or unauthorized use.
                    All users of this system expressly consents to monitoring and are advised that if such monitoring reveals possible evidence of criminal activity, system personnel may provide such evidence to law enforcement officials.
                </h3>
                <hr/>
                <div className="container">
                    <h6 style={{ textTransform: "none" }}>Copyright &copy;2005-2017 Compass Group NAD. All rights reserved.</h6>
                    <h6 style={{ textTransform: "none" }}>SECURITY DISCLAIMER This Computer system is for authorized users only. Individuals using this computer system without authority, or in excess of their authority, are subject to having all their activities on this system monitored and recorded by system personnel. If necessary appropriate action will be taken against individuals when misuse, and/or unauthorized use is detected. These actions could result in counseling, suspension or employment termination depending upon severity. Anyone using this system expressly consents to such monitoring and is advised that if such monitoring reveals possible evidence of criminal activity, system personnel may provide the evidence of such monitoring to law enforcement officials.</h6>
                    <h6 style={{ textTransform: "none" }}>*** Highly Confidential Protected Data. For Limited Internal Use only by Authorized Personnel ***</h6>
                    <h6 style={{ textTransform: "none" }}>*** Not for External Release or Review/Discussion with Unauthorized Personnel ***</h6>
                </div>
            </Container>
        </Container>
    );
}
